import { observer } from 'mobx-react-lite'
import { BulkActionJobErrorDialog } from '@/features/jobs/list/components/BulkActionJobErrorDialog'
import { type BulkActionJobErrorDialogViewModel } from './BulkActionJobErrorDialogViewModel'

export interface BulkActionJobErrorDialogContainerProps {
  vm: BulkActionJobErrorDialogViewModel
}

export const BulkActionJobErrorDialogContainer = observer(
  function BulkActionJobErrorDialogContainer({
    vm,
  }: BulkActionJobErrorDialogContainerProps) {
    return (
      <BulkActionJobErrorDialog
        showing={vm.modal.showing}
        errors={vm.errors}
        onClose={vm.modal.close}
      />
    )
  },
)
